import { decode } from 'he'

export default function encode(text: string) {
    /** Turn &#39; into ' */
    const HTMLunescapedText = decode(text)
    /** Turn & into %26 */
    const URIencodedText = encodeURIComponent(HTMLunescapedText)

    return URIencodedText
}
